import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoadshopEnvironment } from '../app/shared/models/loadshop-environment';

export const environment: LoadshopEnvironment = {
  production: false,
  debug: true,
  apiUrl: 'https://loadshop-api-t1.kbxl.com/loadshop.app.api/v1',
  identityServerUrl: 'https://identity-t1.kbxl.com',
  siteUrl: 'https://loadshop-t1.kbxl.com',
  baseUrl: '/',
  googleKey: 'AIzaSyC3nr_rMsuo9Ku8Q47DLIZBP_Sv9AJmCDc',
  gaTrackingId: 'UA-131254949-1',
  tops2GoApiUrl: 'https://mobile-t1.kbxl.com/t2g',
  recaptchaSiteKey: '6Lds5dsUAAAAAC8Xpi-o1FOSU0ggh5EjcrpGzuVG',
  conversationApiUrl: 'https://api.dev1.kbxl.cloud/exp/api/core/hubmessageapi',
  conversationWebSocketUrl: 'https://api.dev1.kbxl.cloud/exp/api/core/hubwebsocketapi',
};

export const extModules = [
  StoreDevtoolsModule.instrument({
    name: 'LoadShop DevTools',
    maxAge: 150,
  }),
];
